// extracted by mini-css-extract-plugin
module.exports = {"tab":"connections-tab_tab__yLx_e","buttonContainer":"connections-tab_buttonContainer__2819X","actionButton":"connections-tab_actionButton__32Px_"};